import { maxBy } from 'lodash';
import { catchError, of } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';

import { InternalProductWithFavoriteStatusType } from '@sifca-monorepo/ecommerce-generator';

import { AppService, SharedService } from '../../../services';

@Component({
  template: '',
})
export class BaseProductMainPageComponent implements OnInit, OnDestroy {
  loaded = false;
  isLoaded = false;
  posId: string = '';
  relatedProducts: any[];
  internalProductId: string;
  product: InternalProductWithFavoriteStatusType;

  constructor(
    protected router: Router,
    protected appService: AppService,
    protected activeRoute: ActivatedRoute,
    protected sharedService: SharedService,
    protected changeDetectorRef: ChangeDetectorRef,
  ) {
    this.sharedService.posId$.subscribe((posId) => {
      this.posId = posId;
    });
    activeRoute.params.subscribe((params) => {
      this.loaded = false;
      this.isLoaded = false;
      if (this.activeRoute.snapshot.paramMap.get('id')) {
        this.appService
          .getSimpleProductWithFavoriteStatus(params['id'])
          .pipe(
            catchError(() => {
              return of(null);
            }),
          )
          .subscribe();
      } else {
        this.appService
          .getSimpleProductWithFavoriteStatusByUrlKey(this.posId, params['urlKey'])
          .pipe(
            catchError(() => {
              return of(null);
            }),
          )
          .subscribe();
      }
    });
  }

  ngOnInit(): void {
    this.internalProductId = this.activeRoute.snapshot.paramMap.get('id');
    this.appService.product$.subscribe((res: any) => {
      if (res) {
        this.product = res;
        const catalogueCategory = maxBy(this.product.catalogueCategory, 'rank');
        this.appService
          .getSimpleProductsByCatalogueCategoryWithFavoriteStatus(catalogueCategory.id)
          .subscribe();
        this.loaded = true;
        this.changeDetectorRef.markForCheck();
      }
    });
    this.appService.relatedProducts$.subscribe((result) => {
      if (result) {
        this.relatedProducts = result;
        this.isLoaded = true;
        this.changeDetectorRef.markForCheck();
      }
    });
  }

  ngOnDestroy() {
    this.relatedProducts = null;
    this.appService.relatedProducts$ = null;
  }
}
